export const env = {
  apiUrl: import.meta.env.VITE_API_URL as string,
  resetPassUrl: import.meta.env.VITE_RESET_PASS_URL as string,
  mapboxApiKey: import.meta.env.VITE_MAPBOX_API_KEY as string,
  appsignalPushApiKey: import.meta.env.VITE_APPSIGNAL_PUSH_API_KEY as string,
}

export const appVersion = __APP_VERSION__
